var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dinput-date"},[_c('datetime-input',{attrs:{"date-format":_vm.format,"date-type":this.type === 'datetime' ? 'datetime' : 'date'},model:{value:(_vm.response.value),callback:function ($$v) {_vm.$set(_vm.response, "value", $$v)},expression:"response.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }